var _rect, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DZone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 970,
    y: 134,
    width: 103.87,
    height: 23.51,
    rx: 11.755,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M994.033 151.255V150.085L1000.15 141.13H993.981V139.619H1002.3V140.789L996.18 149.744H1002.35V151.255H994.033ZM1014.59 145.437C1014.59 146.679 1014.37 147.747 1013.91 148.641C1013.46 149.532 1012.83 150.217 1012.04 150.698C1011.25 151.175 1010.36 151.414 1009.35 151.414C1008.35 151.414 1007.45 151.175 1006.66 150.698C1005.87 150.217 1005.25 149.53 1004.79 148.636C1004.34 147.742 1004.11 146.675 1004.11 145.437C1004.11 144.194 1004.34 143.128 1004.79 142.238C1005.25 141.344 1005.87 140.658 1006.66 140.181C1007.45 139.7 1008.35 139.46 1009.35 139.46C1010.36 139.46 1011.25 139.7 1012.04 140.181C1012.83 140.658 1013.46 141.344 1013.91 142.238C1014.37 143.128 1014.59 144.194 1014.59 145.437ZM1012.85 145.437C1012.85 144.49 1012.7 143.692 1012.39 143.045C1012.09 142.393 1011.67 141.901 1011.14 141.567C1010.62 141.23 1010.02 141.062 1009.35 141.062C1008.68 141.062 1008.09 141.23 1007.56 141.567C1007.03 141.901 1006.62 142.393 1006.31 143.045C1006.01 143.692 1005.85 144.49 1005.85 145.437C1005.85 146.384 1006.01 147.183 1006.31 147.835C1006.62 148.482 1007.03 148.975 1007.56 149.312C1008.09 149.645 1008.68 149.812 1009.35 149.812C1010.02 149.812 1010.62 149.645 1011.14 149.312C1011.67 148.975 1012.09 148.482 1012.39 147.835C1012.7 147.183 1012.85 146.384 1012.85 145.437ZM1026.65 139.619V151.255H1025.04L1019.13 142.721H1019.02V151.255H1017.26V139.619H1018.89L1024.81 148.164H1024.92V139.619H1026.65ZM1029.7 151.255V139.619H1036.99V141.13H1031.45V144.675H1036.61V146.181H1031.45V149.744H1037.06V151.255H1029.7ZM1048.79 139.619V151.255H1047.02V141.38H1046.96L1044.17 143.198V141.516L1047.08 139.619H1048.79Z",
    fill: "#2E3838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1021.94,
    cy: 224.51,
    r: 25.3,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1021.93,
    cy: 224.51,
    r: 38,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1021.94,
    cy: 224.51,
    r: 13.65,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DZone1);
export default __webpack_public_path__ + "static/media/3d_zone_1.06ed803ff3939b735600c44b9ee7f0fc.svg";
export { ForwardRef as ReactComponent };